// extracted by mini-css-extract-plugin
module.exports = {"roles-switch":"AuthSwitch_roles-switch__2MkgY"};